/* Tab (Oct 13 2026, polished 23:58Z) — selling features (TEST theme): size finder, back-in-stock (Klaviyo), recently viewed writer, bundle message refresh.
   Loaded from layout/theme.liquid. No external libraries. */
(function () {
  'use strict';

  /* ---------- 5. Recently viewed: remember this product (the theme's own recently-viewed-products section reads localStorage "recently-viewed") ---------- */
  function rememberProduct() {
    try {
      var el = document.querySelector('.tpc[data-handle]');
      var key = 'recently-viewed';
      var list = [];
      try { list = JSON.parse(window.localStorage.getItem(key) || '[]'); } catch (e) { list = []; }
      if (!Array.isArray(list)) list = [];
      if (el && el.getAttribute('data-handle')) {
        var h = el.getAttribute('data-handle');
        list = list.filter(function (x) { return x !== h; });
        list.unshift(h);
        list = list.slice(0, 12);
      }
      window.localStorage.setItem(key, JSON.stringify(list));
      window.recentlyViewedIds = list;
    } catch (e) { /* private mode: nothing to remember */ }
  }
  rememberProduct();

  /* ---------- 1. Bundle & save: keep the cart message current after cart changes ---------- */
  /* Oct 14 2026: the 9 three-packs joined the deal - any mix of sets & packs counts (same rule as snippets/tab-bundle-msg.liquid) */
  var SET_RE = /\bSet\b|\bPack\b/, SET_HANDLE_RE = /set|pack/;
  function inBundle(it) { return SET_RE.test(it.product_title || '') || SET_HANDLE_RE.test(it.handle || ''); }
  function bundleText(n) {
    if (n <= 0) return '';
    if (n === 1) return 'Add 1 more set or pack and save 10% on both';
    if (n === 2) return 'You\u2019re saving 10% on your bundle \u2014 add 2 more to save 15%';
    if (n === 3) return 'You\u2019re saving 10% on your bundle \u2014 add 1 more to save 15%';
    return 'You\u2019re saving 15% on your bundle';
  }
  function paintBundle(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) { if (inBundle(it)) n += it.quantity || 0; });
    document.querySelectorAll('[data-tab-bundle]').forEach(function (el) {
      el.setAttribute('data-sets', n);
      var t = el.querySelector('.tb-bundle__t'); if (t) t.textContent = bundleText(n);
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }
  var bt; function refreshBundle() {
    if (!document.querySelector('[data-tab-bundle]')) return;
    clearTimeout(bt); bt = setTimeout(function () {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(paintBundle).catch(function () {});
    }, 300);
  }
  ['cart:refresh', 'line-item:change:end', 'cart:updated', 'cart-drawer:open', 'product:added'].forEach(function (ev) { document.addEventListener(ev, refreshBundle); });
  function outsideBundle(muts) { return muts.some(function (m) { var t = m && m.target; if (!t) return false; var n = t.nodeType === 1 ? t : t.parentElement; return !(n && n.closest && n.closest('[data-tab-bundle]')); }); }
  function watchCart() {
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer && 'MutationObserver' in window) new MutationObserver(function (m) { if (outsideBundle(m)) refreshBundle(); }).observe(drawer, { childList: true, subtree: true });
    var cart = document.getElementById('Cart');
    if (cart && 'MutationObserver' in window) new MutationObserver(function (m) { if (outsideBundle(m)) refreshBundle(); }).observe(cart, { childList: true });
  }

  /* ---------- helpers for the product page ---------- */
  function variantsJSON(section) {
    var sc = section.querySelector('variant-selects script[type="application/json"]');
    if (!sc) return [];
    try { return JSON.parse(sc.textContent); } catch (e) { return []; }
  }
  function selectedOptions(section) {
    var out = [];
    section.querySelectorAll('variant-selects fieldset').forEach(function (fs) {
      var r = fs.querySelector('input[type="radio"]:checked');
      out.push(r ? r.value : null);
    });
    return out;
  }
  function currentVariant(section) {
    var opts = selectedOptions(section);
    if (!opts.length) return null;
    var vs = variantsJSON(section);
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i], ok = true;
      for (var j = 0; j < opts.length; j++) { if (opts[j] !== null && v.options[j] !== opts[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }

  /* ---------- 3. Back in stock: show the form on sold-out variants, subscribe through Klaviyo's client API ---------- */
  function initBackInStock(section) {
    var box = section.querySelector('[data-tab-bis]') || document.querySelector('[data-tab-bis]');
    if (!box) return;
    var form = box.querySelector('form'), input = box.querySelector('input[type="email"]'), btn = box.querySelector('.tbis__btn'), msg = box.querySelector('.tbis__msg'), ttl = box.querySelector('[data-tbis-title]');
    function sync() {
      var v = currentVariant(section);
      if (!v) return;
      box.setAttribute('data-variant', v.id);
      if (ttl) ttl.textContent = (v.title || '').replace(/ \/ /g, ', ');
      var buybox = (box.closest && box.closest('.tpc-buybox')) || section;
      if (v.available) { box.setAttribute('hidden', ''); buybox.classList.remove('tab-bis-on'); }
      else { box.removeAttribute('hidden'); box.classList.remove('is-done'); buybox.classList.add('tab-bis-on'); if (msg) { msg.textContent = ''; msg.className = 'tbis__msg'; } }
    }
    section.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-selects')) setTimeout(sync, 0); });
    sync();
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { msg.textContent = 'Please enter a valid email address.'; msg.className = 'tbis__msg is-err'; input.focus(); return; }
      var company = box.getAttribute('data-company'), variant = box.getAttribute('data-variant');
      if (!company || !variant) { msg.textContent = 'Sorry, something went wrong. Please try again.'; msg.className = 'tbis__msg is-err'; return; }
      btn.setAttribute('disabled', ''); msg.textContent = 'Saving\u2026'; msg.className = 'tbis__msg';
      var body = { data: { type: 'back-in-stock-subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email } } }, channels: ['EMAIL'] }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant } } } } };
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(company), { method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' }, body: JSON.stringify(body) })
        .then(function (r) {
          if (r.status === 202) { box.classList.add('is-done'); msg.textContent = 'You\u2019re on the list. We\u2019ll email ' + email + ' when this size is back.'; msg.className = 'tbis__msg is-ok'; }
          else { return r.text().then(function () { throw new Error('status ' + r.status); }); }
        })
        .catch(function () { msg.textContent = 'Sorry, that didn\u2019t go through. Please try again in a moment.'; msg.className = 'tbis__msg is-err'; })
        .then(function () { btn.removeAttribute('disabled'); });
    });
  }

  /* ---------- 2. Find my size ---------- */
  var CHART = [ /* the brand's kids size chart (the same table on every kids style): size, height in, weight lb */
    { s: '3-4', h: [39, 43], w: [33, 40] },
    { s: '5-6', h: [44, 47], w: [40, 50] },
    { s: '7-8', h: [48, 51], w: [50, 62] },
    { s: '9-10', h: [52, 55], w: [62, 75] },
    { s: '11-12', h: [56, 59], w: [75, 88] },
    { s: '13-14', h: [60, 63], w: [88, 110] },
    { s: '15-16', h: [64, 67], w: [110, 132] }
  ];
  function fmt1(v) { var n = parseFloat(v); return isNaN(n) ? '' : String(Math.round(n * 10) / 10); } /* the value as typed, at most one decimal (43.5 stays 43.5) */
  function idxByHeight(h) { for (var i = 0; i < CHART.length; i++) { if (h <= CHART[i].h[1]) return i; } return CHART.length; }
  function idxByWeight(w) { for (var i = 0; i < CHART.length; i++) { if (w <= CHART[i].w[1]) return i; } return CHART.length; }
  function idxByAge(a) { for (var i = 0; i < CHART.length; i++) { var p = CHART[i].s.split('-'); if (a <= parseInt(p[1], 10)) return i; } return CHART.length; }

  function initSizeFinder(section) {
    var modal = document.getElementById('TsfModal-' + section.getAttribute('data-section'));
    if (!modal) return;
    var offered = (modal.getAttribute('data-sizes') || '').split(',').filter(Boolean);
    var hUnit = 'in', wUnit = 'lb';
    var hIn = modal.querySelector('[data-tsf-h]'), wIn = modal.querySelector('[data-tsf-w]'), aIn = modal.querySelector('[data-tsf-a]');
    var err = modal.querySelector('.tsf-err'), res = modal.querySelector('.tsf-result'), rSize = modal.querySelector('.tsf-result__size'), rWhy = modal.querySelector('.tsf-result__why'), rNote = modal.querySelector('.tsf-result__note'), pick = modal.querySelector('.tsf-pick');
    modal.querySelectorAll('.tsf-unit button').forEach(function (b) {
      b.addEventListener('click', function () {
        var u = b.getAttribute('data-unit');
        if (b.parentElement) b.parentElement.querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        if (u === 'in' || u === 'cm') { hUnit = u; hIn.placeholder = u === 'in' ? 'e.g. 50' : 'e.g. 127'; }
        else { wUnit = u; wIn.placeholder = u === 'lb' ? 'e.g. 58' : 'e.g. 26'; }
      });
    });
    function recommend() {
      err.textContent = ''; res.classList.remove('is-shown'); pick.setAttribute('hidden', '');
      var h = parseFloat(hIn.value), w = parseFloat(wIn.value), a = parseInt(aIn.value, 10);
      if (hUnit === 'cm' && !isNaN(h)) h = h / 2.54;
      if (wUnit === 'kg' && !isNaN(w)) w = w * 2.2046;
      var hasH = !isNaN(h) && h > 0, hasW = !isNaN(w) && w > 0, hasA = !isNaN(a) && a > 0;
      if (!hasH && !hasW && !hasA) { err.textContent = 'Enter your child\u2019s height and weight (or at least their age).'; return; }
      if (hasH && (h < 30 || h > 80)) { err.textContent = 'That height doesn\u2019t look right \u2014 please check it (' + (hUnit === 'cm' ? 'in cm' : 'in inches') + ').'; return; }
      if (hasW && (w < 20 || w > 220)) { err.textContent = 'That weight doesn\u2019t look right \u2014 please check it (' + (wUnit === 'kg' ? 'in kg' : 'in lb') + ').'; return; }
      var ih = hasH ? idxByHeight(h) : -1, iw = hasW ? idxByWeight(w) : -1, ia = hasA ? idxByAge(a) : -1;
      var idx, why, note = '';
      if (hasH || hasW) {
        idx = Math.max(ih, iw);                      /* between sizes: size up for comfort (the chart's own rule) */
        var parts = [];
        if (hasH) parts.push('height ' + fmt1(hIn.value) + '\u00a0' + hUnit + (ih < CHART.length ? ' \u2192 ' + CHART[ih].s : ''));
        if (hasW) parts.push('weight ' + fmt1(wIn.value) + '\u00a0' + wUnit + (iw < CHART.length ? ' \u2192 ' + CHART[iw].s : ''));
        why = 'Based on this product\u2019s size chart: ' + parts.join(', ') + '.';
        if (hasH && hasW && ih !== iw) note = 'Height and weight point to different sizes, so we suggest the larger one for comfort and room to grow.';
        if (hasA && ia !== idx && ia >= 0) note += (note ? ' ' : '') + 'Age is a rough guide only \u2014 height and weight matter more.';
      } else {
        idx = ia; why = 'Based on age ' + a + '. For a closer match, add height and weight.';
      }
      if (idx >= CHART.length) { rSize.textContent = CHART[CHART.length - 1].s; rWhy.textContent = why; rNote.textContent = 'This is above the chart\u2019s largest size (' + CHART[CHART.length - 1].s + '); it may run small.'; res.classList.add('is-shown'); highlight(CHART[CHART.length - 1].s); offer(CHART[CHART.length - 1].s); return; }
      var size = CHART[idx].s;
      if (offered.length && offered.indexOf(size) === -1) {
        var smallest = offered[0], largest = offered[offered.length - 1];
        var ci = CHART.map(function (c) { return c.s; });
        if (ci.indexOf(size) < ci.indexOf(smallest)) { note += (note ? ' ' : '') + 'This style starts at size ' + smallest + ', the closest size available.'; size = smallest; }
        else if (ci.indexOf(size) > ci.indexOf(largest)) { note += (note ? ' ' : '') + 'This style goes up to size ' + largest + '; a ' + CHART[idx].s + ' would be a closer fit.'; size = largest; }
      }
      rSize.textContent = size; rWhy.textContent = why; rNote.textContent = note; res.classList.add('is-shown');
      highlight(size); offer(size);
    }
    function highlight(size) { modal.querySelectorAll('.tsf-table tr[data-size]').forEach(function (tr) { tr.classList.toggle('is-rec', tr.getAttribute('data-size') === size); }); }
    function offer(size) {
      var radio = null;
      section.querySelectorAll('.tpc-sizes input[type="radio"]').forEach(function (r) { if (r.value === size) radio = r; });
      if (radio) { pick.textContent = 'Select size ' + size; pick.removeAttribute('hidden'); pick.onclick = function () { radio.click(); modal.hide(); }; }
    }
    modal.querySelector('.tsf-go').addEventListener('click', recommend);
    modal.querySelectorAll('input').forEach(function (i) { i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); recommend(); } }); });
  }

  function init() {
    watchCart();
    document.querySelectorAll('.tpc[data-section]').forEach(function (section) {
      try { initBackInStock(section); } catch (e) { /* keep the page working */ }
      try { initSizeFinder(section); } catch (e) { /* keep the page working */ }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* ---------- 9. WhatsApp chat (Oct 14 2026): keep the floating button clear of the phone sticky add-to-cart bar / Klaviyo teaser bar, and add "Chat on WhatsApp" next to the store phone number (footer HELP column, contact page) ---------- */
  var WA_URL = 'https://wa.me/18454923100?text=Hi%20Essenclo%2C%20I%20have%20a%20question';
  var WA_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>';
  function waPlace() {
    var btn = document.querySelector('.tab-wa');
    if (!btn) return;
    var vw = window.innerWidth, vh = window.innerHeight;
    var base = vw >= 750 ? 20 : 12; /* Oct 14 2026 (9:34 AM, smaller again): 12 px from the corner on phones, 20 px on desktop */
    var zoneLeft = vw - base - (btn.offsetWidth || 44) - 12;
    var lift = 0;
    document.querySelectorAll('.tpc-sticky, [class*="kl-teaser"]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.width < 40 || r.height < 20 || r.top >= vh || r.bottom < vh - 24 || r.right < zoneLeft) return; /* not a visible bar sitting at the bottom under the button */
      lift = Math.max(lift, vh - r.top);
    });
    var b = lift ? Math.round(lift + 10) : base;
    if (btn.style.bottom !== b + 'px') btn.style.bottom = b + 'px';
    var btt = document.querySelector('back-to-top.back-to-top'); /* keep the theme's back-to-top arrow 8 px above the button */
    if (btt) { var bb = Math.round(b + (btn.offsetHeight || 44) + 8) + 'px'; if (btt.style.bottom !== bb) btt.style.bottom = bb; }
  }
  function waInline() {
    document.querySelectorAll('a[href^="tel:"]').forEach(function (a) {
      if (!/8454923100$/.test((a.getAttribute('href') || '').replace(/\D/g, '')) || a.getAttribute('data-tab-wa')) return;
      var n = a.nextSibling; /* only when the number ends its line/paragraph (not mid-sentence) */
      while (n && n.nodeType === 3 && !n.textContent.trim()) n = n.nextSibling;
      if (n) return;
      a.setAttribute('data-tab-wa', '1');
      var sep = document.createElement('span'); sep.className = 'tab-wa-sep'; sep.textContent = ' \u00b7 ';
      var l = document.createElement('a'); l.className = 'tab-wa-inline'; l.href = WA_URL; l.target = '_blank'; l.rel = 'noopener';
      l.innerHTML = WA_SVG + '<span>Chat on WhatsApp</span>';
      a.parentNode.insertBefore(sep, a.nextSibling); a.parentNode.insertBefore(l, sep.nextSibling);
    });
  }
  (function () {
    if (!document.querySelector('.tab-wa') && !document.querySelector('a[href^="tel:"]')) return;
    var t1 = 0, t2 = 0;
    function queue() { if (!t1) t1 = requestAnimationFrame(function () { t1 = 0; waPlace(); }); clearTimeout(t2); t2 = setTimeout(waPlace, 350); /* again after the sticky bar's slide transition */ }
    waInline(); waPlace();
    window.addEventListener('resize', queue); window.addEventListener('scroll', queue, { passive: true });
    if (window.MutationObserver) new MutationObserver(queue).observe(document.body, { childList: true, attributes: true, attributeFilter: ['class', 'style'], subtree: true });
    setTimeout(waPlace, 1500); setTimeout(waPlace, 4000); /* Klaviyo's teaser arrives late */
  })();
  /* ---------- 10. PDP colour swatches (Oct 14 2026, Abraham 7:07 AM): tapping a swatch focuses its hidden radio, and Chrome/Android then scrolls the focused radio into the middle of the screen. The radios sat at the grid's top-left corner, so every tap jumped the grid (and the page) back to row 1. Now: (a) each radio is parked over its own swatch, and (b) a tap on a swatch checks the radio ourselves and focuses it without scrolling (the theme still gets the bubbling 'change' event). With the grid no longer a scroll box (tab-features.css section 11) nothing can jump. ---------- */
  (function () {
    function park() {
      document.querySelectorAll('.tpc-vthumbs').forEach(function (row) {
        row.querySelectorAll('input.tpc-radio').forEach(function (inp) {
          var lab = inp.nextElementSibling;
          if (!lab || lab.tagName !== 'LABEL') lab = inp.id ? row.querySelector('label[for="' + inp.id + '"]') : null;
          if (!lab) return;
          var top = lab.offsetTop + 'px', left = lab.offsetLeft + 'px';
          if (inp.style.top !== top) inp.style.top = top;
          if (inp.style.left !== left) inp.style.left = left;
        });
      });
    }
    document.addEventListener('click', function (e) {
      var lab = e.target && e.target.closest ? e.target.closest('.tpc-vthumbs label') : null;
      if (!lab) return;
      var inp = lab.control || (lab.htmlFor ? document.getElementById(lab.htmlFor) : null) || lab.previousElementSibling;
      if (!inp || inp.type !== 'radio' || inp.disabled) return;
      e.preventDefault();
      if (!inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
      try { inp.focus({ preventScroll: true }); } catch (x) {}
      queue();
    }, true);
    var t = 0; function queue() { clearTimeout(t); t = setTimeout(park, 60); }
    if (!document.querySelector('.tpc-vthumbs')) return;
    park(); window.addEventListener('resize', queue); window.addEventListener('load', park);
    setTimeout(park, 800); setTimeout(park, 2500);
  })();
})();
